import React from "react";
import { useHistory } from "react-router-dom";

import { BasicButton, ButtonType } from "@gaming/xds-react-js";

import { xboxOnboardSiteLocationPrefix } from "../../constants";
import { useStrings } from "../../localization/localizationHelpers";
import * as styles from "./PartnerEnrollmentRequired.module.css";

type PartnerEnrollmentRequiredProps = Readonly<{
  title: string;
  description: string;
}>;

export const PartnerEnrollmentRequired = ({
  title,
  description,
}: PartnerEnrollmentRequiredProps) => {
  const history = useHistory();
  const [actionLabel] = useStrings("partnerEnrollmentRequiredAction");

  return (
    <section className={styles.container}>
      <h1 className={styles.title}>{title}</h1>
      <p className={styles.description}>{description}</p>
      <BasicButton
        as="button"
        buttonType={ButtonType.Secondary}
        type="button"
        onClick={() => history.push(`${xboxOnboardSiteLocationPrefix}/dashboard`)}
      >
        {actionLabel}
      </BasicButton>
    </section>
  );
};
